import { jsx as _jsx } from "react/jsx-runtime";
import { Stack } from "@mui/material";
import { Panel } from "@pangeacyber/react-mui-authn";
var HostedLayout = function (_a) {
    var branding = _a.branding, children = _a.children;
    return (_jsx(Stack, { height: "100%", children: _jsx(Panel, { brandName: branding.authn_show_name === "yes" ? branding.brand_name : "", logoUrl: branding.brand_logo, logoHeight: branding.brand_logo_height, bgColor: branding.bg_color, bgImage: branding.bg_image, density: branding.density, children: children }) }));
};
export default HostedLayout;
